<script>
export default {
  name: "new-qrcode-icon",
};
</script>

<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_18_5)">
      <path
        d="M5.99598 1.33333C4.1314 1.37596 3.04232 1.55407 2.2982 2.29819C1.55409 3.04231 1.37598 4.13139 1.33334 5.99597M10.004 1.33333C11.8686 1.37596 12.9577 1.55407 13.7018 2.29819C14.4459 3.04231 14.624 4.13139 14.6667 5.99597M10.004 14.6667C11.8686 14.624 12.9577 14.4459 13.7018 13.7018C14.4459 12.9577 14.624 11.8686 14.6667 10.004M5.99598 14.6667C4.1314 14.624 3.04232 14.4459 2.2982 13.7018C1.55409 12.9577 1.37598 11.8686 1.33334 10.004"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3332 4.66666H11.3392"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.66667 4V6C8.66667 7.25708 8.66667 7.88562 8.27614 8.27614C7.88562 8.66667 7.25708 8.66667 6 8.66667H4"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M4.19526 4.19526C4 4.39052 4 4.70479 4 5.33333C4 5.96187 4 6.27614 4.19526 6.4714M4.19526 4.19526C4.39052 4 4.70479 4 5.33333 4C5.96187 4 6.27614 4 6.4714 4.19526M4.19526 4.19526C4.19526 4.19526 4.19526 4.19526 4.19526 4.19526ZM4.19526 6.4714C4.39052 6.66667 4.70479 6.66667 5.33333 6.66667C5.96187 6.66667 6.27614 6.66667 6.4714 6.4714M4.19526 6.4714C4.19526 6.4714 4.19526 6.4714 4.19526 6.4714ZM6.4714 6.4714C6.66667 6.27614 6.66667 5.96187 6.66667 5.33333C6.66667 4.70479 6.66667 4.39052 6.4714 4.19526M6.4714 6.4714C6.4714 6.4714 6.4714 6.4714 6.4714 6.4714ZM6.4714 4.19526C6.4714 4.19526 6.4714 4.19526 6.4714 4.19526Z"
        stroke="white"
        stroke-width="1.5"
      />
      <path
        d="M11.3333 10C11.6476 10 11.8047 10 11.9024 10.0976C12 10.1953 12 10.3524 12 10.6667V11.3333C12 11.6476 12 11.8047 11.9024 11.9024C11.8047 12 11.6476 12 11.3333 12H10C9.68574 12 9.52861 12 9.43097 11.9024C9.33334 11.8047 9.33334 11.6476 9.33334 11.3333L9.33334 10.6667C9.33334 10.3524 9.33334 10.1953 9.43097 10.0976C9.52861 10 9.68574 10 10 10L11.3333 10Z"
        stroke="white"
        stroke-width="1.5"
      />
      <path
        d="M4 12H7.33333"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M11.3333 6.66666L11.3333 7.99999"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_18_5">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
